import React, { useEffect, useRef } from "react";

const CELL_SIZE = 100;

export default function Background() {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const paintGrid = () => {
      const grid = containerRef.current;
      if (!grid) return;

      const viewportWidth = window.innerWidth;
      const columns = Math.ceil(viewportWidth / CELL_SIZE);

      const cells = Array.from(
        grid.querySelectorAll<HTMLDivElement>(".grid-cell")
      );

      // Reset colors first (important on resize)
      cells.forEach((cell) => {
        cell.style.backgroundColor = "rgb(44, 44, 44)";
      });

      // Group cells into rows
      const rowsCells = Array(Math.ceil(cells.length / columns))
        .fill(null)
        .map((_, rowIndex) =>
          cells.slice(rowIndex * columns, (rowIndex + 1) * columns)
        );

      // Random highlight per row
      rowsCells.forEach((row) => {
        const selectedCells = [...row]
          .sort(() => Math.random() - 0.5)
          .slice(0, 1); // 🔹 1 cell per row (safer on mobile)

        selectedCells.forEach((cell) => {
          cell.style.backgroundColor = "#383838";
        });
      });
    };

    paintGrid();
    window.addEventListener("resize", paintGrid);
    return () => window.removeEventListener("resize", paintGrid);
  }, []);

  return (
    <div className="fixed inset-0 w-screen h-screen overflow-hidden pointer-events-none">
      {/* Grid pattern */}
      <div
        ref={containerRef}
        className="absolute inset-0"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(100, ${CELL_SIZE}px)`, // 🔹 NO auto-fill
          gridAutoRows: `${CELL_SIZE}px`,
          width: "100vw", // 🔹 force viewport width
          height: "100vh",
          backgroundColor: "rgb(44, 44, 44)",
          zIndex: -1,
        }}
      >
        {Array.from({ length: 1200 }).map((_, index) => (
          <div
            key={index}
            className="grid-cell"
            style={{
              width: `${CELL_SIZE}px`,
              height: `${CELL_SIZE}px`,
              backgroundColor: "rgb(44, 44, 44)",
              boxShadow: "0 0 0 0.5px #6f7072",
            }}
          />
        ))}
      </div>

      {/* Top Glow */}
      <div
        className="absolute"
        style={{
          width: "1650px",
          height: "1600px",
          left: "-250px",
          top: "-850px",
          background:
            "radial-gradient(closest-side, rgba(220,210,210,0.2) 0%, rgba(210,210,210,0.2) 100%)",
          filter: "blur(65px)",
          zIndex: -1,
        }}
      />

      {/* Left Fade */}
      <div
        className="absolute inset-y-0 left-0 w-1/2 md:w-1/4"
        style={{
          background:
            "linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0))",
          zIndex: -1,
        }}
      />

      {/* Right Fade */}
      <div
        className="absolute inset-y-0 right-0 w-1/2 md:w-1/4"
        style={{
          background:
            "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
          zIndex: -1,
        }}
      />

      {/* Bottom Fade */}
      <div
        className="absolute bottom-0 left-0 w-full"
        style={{
          background:
            "linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0))",
          height: "500px",
          zIndex: -1,
        }}
      />
    </div>
  );
}
